(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["overseas-fast-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const regionNames = {
      EU: 'European Union',
      UK: 'United Kingdom',
      US: 'United States',
      CA: 'Canada'
    };

    const formatList = (items) => {
      if (typeof Intl !== 'undefined' && Intl.ListFormat) {
        return new Intl.ListFormat(document.documentElement.lang || 'en', {
          style: 'long',
          type: 'conjunction'
        }).format(items);
      }
      if (items.length < 2) return items[0] || '';
      return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
    };

    const initialize = (root) => {
      if (root.dataset.overseasFastDeliveryReady === 'true') return;

      const variantData = root.querySelector('[data-fast-delivery-variant-regions]');
      const regionCopy = root.querySelector('[data-fast-delivery-region-copy]');
      if (!variantData || !regionCopy) return;

      let variants = [];
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        console.warn('Fast delivery region data could not be parsed.', error);
        return;
      }

      const scope = root.closest('.shopify-section') || document;
      const productForm = scope.querySelector('form[action*="/cart/add"]');
      const variantInput = productForm?.querySelector('[name="id"]');

      const render = (variantId) => {
        const variant = variants.find((item) => String(item.id) === String(variantId));
        const regionCodes = Array.isArray(variant?.regions)
          ? [...new Set(variant.regions.map((region) => String(region).trim().toUpperCase()).filter(Boolean))]
          : [];

        const visible = regionCodes.length > 0;
        root.hidden = !visible;
        root.setAttribute('aria-hidden', String(!visible));

        if (visible) {
          const names = regionCodes.map((code) => regionNames[code] || code);
          regionCopy.textContent = `Fast delivery available from ${formatList(names)}.`;
        } else {
          regionCopy.textContent = '';
        }
      };

      const update = () => {
        const urlVariantId = new URLSearchParams(window.location.search).get('variant');
        render(variantInput?.value || urlVariantId);
      };

      const scheduleUpdate = () => window.requestAnimationFrame(update);

      productForm?.addEventListener('change', scheduleUpdate);
      document.addEventListener('variant:change', (event) => {
        const variantId = event.detail?.variant?.id;
        variantId ? render(variantId) : scheduleUpdate();
      });
      window.addEventListener('popstate', scheduleUpdate);

      root.dataset.overseasFastDeliveryReady = 'true';
      update();
    };

    const initializeAll = (container = document) => {
      container.querySelectorAll('[data-overseas-fast-delivery]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
